const actions = {
  USERS_REPORTS_REQUEST: "USERS_REPORTS_REQUEST",
  USERS_REPORTS_SUCCESS: "USERS_REPORTS_SUCCESS",

  usersReports: (startDate, endDate, selectedRestaurant) => {
    return (dispatch) => {
      dispatch({
        type: actions.USERS_REPORTS_REQUEST,
        startDate,
        endDate,
        selectedRestaurant,
      });
    };
  },
};
export default actions;
